module.exports = __webpack_public_path__ + "static/media/COZINHA PRATIC.68eade6c.png";